import React from "react";

export const ParkingAreaIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="30" height="31" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g filter="url(#filter0_d)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.00484 5.96908C9.00484 6.74965 9.1885 7.57614 9.55583 8.49445C10.8874 11.7086 14.4688 15.7492 14.6525 15.9328C14.6984 16.0247 14.8362 16.0706 14.9739 16.0706C15.1117 16.0706 15.2494 16.0247 15.3412 15.8869C15.479 15.7492 19.0604 11.6627 20.392 8.49445C20.6216 7.89755 20.943 6.97923 20.943 5.96908C20.943 2.66313 18.2799 0 14.9739 0C11.668 0 9.00484 2.66313 9.00484 5.96908ZM14.9739 2.2958C12.9536 2.2958 11.3006 3.94877 11.3006 5.96908C11.3006 7.98938 12.9536 9.64235 14.9739 9.64235C16.9942 9.64235 18.6472 7.98938 18.6472 5.96908C18.6472 3.94877 16.9942 2.2958 14.9739 2.2958ZM25.9937 21.0295L23.698 10.0097C23.652 9.87193 23.5602 9.73419 23.4684 9.68827L21.6317 8.76995L21.2185 9.59644L22.8715 10.4229L25.0754 21.0754L20.2543 18.4582C20.1165 18.3664 19.9328 18.3664 19.7951 18.4582L14.9739 21.0754L10.1527 18.4582C10.015 18.3664 9.83133 18.3664 9.69358 18.4582L4.91832 21.0295L7.12229 10.377L8.77526 9.55052L8.36202 8.72403L6.52538 9.64235C6.38763 9.68827 6.2958 9.82602 6.2958 9.96377L4 20.9836V21.0754V21.5346C4 21.8101 4.18366 21.9937 4.45916 21.9937H4.91832C5.01015 21.9937 5.05607 21.9937 5.1479 21.9478L9.92316 19.3306L14.7443 21.9478C14.8821 22.0397 15.0657 22.0397 15.2035 21.9478L20.0247 19.3306L24.8458 21.9478C24.9377 22.0397 24.9836 22.0397 25.0754 22.0397H25.5346C25.8101 22.0397 25.9937 21.856 25.9937 21.5805V21.1213V21.0295ZM14.5148 17.9072V16.9889H15.4331V17.9072H14.5148ZM14.5148 18.8255V19.7439H15.4331V18.8255H14.5148ZM12.219 5.96908C12.219 7.4843 13.4587 8.72403 14.9739 8.72403C16.4891 8.72403 17.7289 7.4843 17.7289 5.96908C17.7289 4.45385 16.4891 3.21412 14.9739 3.21412C13.4587 3.21412 12.219 4.45385 12.219 5.96908ZM9.92316 5.96908C9.92316 6.6119 10.0609 7.34656 10.4282 8.17304C11.4384 10.6525 14.0556 13.8207 14.9739 14.9227C15.8922 13.8207 18.5094 10.6525 19.5196 8.17304C19.8869 7.34656 20.0247 6.65782 20.0247 5.96908C20.0247 3.1682 17.7748 0.918319 14.9739 0.918319C12.173 0.918319 9.92316 3.1682 9.92316 5.96908ZM14.5148 5.50992H15.4331V6.42824H14.5148V5.50992Z"
        fill="#F3F3F4"
      />
    </g>
    <defs>
      <filter
        id="filter0_d"
        x="0"
        y="0"
        width="29.9937"
        height="30.0397"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
      </filter>
    </defs>
  </svg>
);
